<template>
  <div class="bg-F5F5F5 relative scroll-y h-fullVh">
    <common-empty-wechat :type="type" :content="text">
      <p v-if="type === 'noInfo'" class="text-center font-34 mb-4">未查询到家长信息</p>
    </common-empty-wechat>
  </div>
</template>

<script>
import { commonEmptyWechat } from '@/components'
export default {
  name: 'PageWechatEmpty',
  components: {
    commonEmptyWechat
  },
  data() {
    return {
      type: this.$route.query.type,
      text: this.$route.query.type === 'noInfo' ? '请联系老师在家校通讯录添加家长信息' : '链接已失效'
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
